import initTestCaseList from 'ee/test_case_list/test_case_list_bundle';

initTestCaseList({
  mountPointSelector: '#js-test-cases-list',
});
